export default __webpack_public_path__ + "static/media/uwa.69de3c3e.jpeg";